import * as React      from "react"
import PropTypes       from "prop-types"
import _               from "lodash"
import { Pie, Bar }    from "react-chartjs-2"
import { injectIntl }  from "react-intl"
import InvestmentTable from "./investment-table"
import ModalChart      from "../modal-chart"
import ExportTable     from "../export-table"

export const CHART_SECTIONS = {
	INVESTMENT : "CHART_SECTIONS.INVESTMENT"
}

class InvestmentComponent extends React.Component {
	constructor(props) {
		super(props)

		this.defaultTitleOptions = { display: true}

		this.pieChartOptions = {
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]
					const total          = _.sum(data.datasets[datasetIndex].data)
					const percentage     = total ? _.round(value * 100 / total) : 0
					const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					return `${data.labels[dataIndex]} : ${formattedValue} (${percentage}%)`
				}
			}}
		}

		this.defaultBarChartOptions = {
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						callback: (value, index, values) => (
						this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					)}},
					{
						gridLines: { display: false },
						id       : "inhabitants",
						position : "right",
						ticks    : { callback: (value, index, values) => (this.props.intl.formatNumber(value)) }
					}
				]},
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]

					if (data.datasets.length === datasetIndex - 1) {
						const total          = _.sum(data.datasets[datasetIndex].data)
						const percentage     = total ? _.round(value * 100 / total) : 0
						const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
						return `${data.datasets[datasetIndex].label} : ${formattedValue} (${percentage}%)`
					} else {
						const formattedValue = this.props.intl.formatNumber(value)
						return `${data.datasets[datasetIndex].label} : ${formattedValue}`
					}
				}
			}}
		}

		this.perInhabitantChartOptions = {
			...this.defaultBarChartOptions
		}

		this.modalTabs = [
			{ id: CHART_SECTIONS.INVESTMENT, label: "Investissement" }
		]
	}

	render() {
		const loading       = this.props.loading
		const displayCharts = this.props.displayCharts
		const firstYear     = this.props.years[0]
		const lastYear      = _.last(this.props.years).toString()
		const titleOptions  = this._getTitleOptions(this.props, firstYear, lastYear)
		const height        = 180

		return (
			<div style={{ height: "100%", overflow: "auto", width: "100%" }}>
				{!loading && <button className="button is-text" onClick={this.props.onClickShowCharts}>Afficher les graphiques</button>}
				<ExportTable data={this.props.tableData} slug={this.props.slug} id={this.props.id} years={this.props.years} />

				<InvestmentTable data={this.props.tableData} years={this.props.years} />

				{displayCharts && (
					<ModalChart
					displayCharts     = {displayCharts}
					onClickHideCharts = {this.props.onClickHideCharts}
					onClickShowCharts = {this.props.onClickShowCharts}
					title             = "Investissement">

						{this.props.pieChartData && <Pie data={this.props.pieChartData.lastYear} options={{...this.pieChartOptions, title: titleOptions.dotationLastYear}} />}
						{this.props.pieChartData && <Pie data={this.props.pieChartData.prevYears} options={{...this.pieChartOptions, title: titleOptions.dotationPrevYear}} />}

					</ModalChart>
				)}
			</div>
		)
	}

	_getTitleOptions = (props, firstYear, lastYear) => {
		const defaultTitleOptions = { display: true }
		return {
			dotationLastYear: {
				...defaultTitleOptions,
				text: 'Investissement en ' + lastYear
			},
			dotationPrevYear: {
				...defaultTitleOptions,
				text: 'Investissement de ' + firstYear + ' à ' + lastYear
			}
		}
	}
}

export default injectIntl(InvestmentComponent)

InvestmentComponent.propTypes = {
	loading             : PropTypes.bool.isRequired,
	years               : PropTypes.arrayOf(PropTypes.number).isRequired
}


// WEBPACK FOOTER //
// ./src/component/ratios/investment/investment-component.js